import DynamicTable from '@atlaskit/dynamic-table';
import { MarketplaceBillingCycle } from '@atlassian/mpac-types/graphql-gateway-types';
import React from 'react';
import { PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS } from '../../../../../constants';
import { getTierCeiling } from '../PricingCalculatorSection/CloudPricingCalculator/CloudPricingCalculator.utils';
import { formatAmount } from '../PricingTab.utils';
import { PricingTierTableAmountCell as AmountCell, PricingTierTableCell as UnitCell } from '../PricingTiers/PricingTiers.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const getUptoText = (tierCeiling, isAnnualBillingCycle) => {
  return "Up to ".concat(tierCeiling) + (isAnnualBillingCycle ? '' : ' (Flat fee)');
};
const getHeader = billingCycle => {
  return [{
    isSortable: false,
    key: 'ceiling',
    content: 'Team Size'
  }, {
    isSortable: false,
    key: 'price',
    content: /*#__PURE__*/_jsx(AmountCell, {
      children: billingCycle === MarketplaceBillingCycle.Annual ? 'Annual price' : 'Monthly per user'
    })
  }];
};
const createPricingTiers = (tiers, currency, billingCycle) => {
  return tiers.map(tier => {
    const ceiling = getTierCeiling(tier);
    const uptoText = getUptoText(ceiling, billingCycle === MarketplaceBillingCycle.Annual);
    return {
      teamSize: tier.floor === 1 ? uptoText : "".concat(tier.floor, "-").concat(ceiling),
      price: tier.amount === 0 ? 'Free' : formatAmount(tier.amount, {
        currency,
        minimumFractionDigits: PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS
      })
    };
  });
};
const getRows = (items, currency, billingCycle) => {
  const examples = createPricingTiers(items, currency, billingCycle);
  return examples.map(example => {
    const cells = [{
      content: /*#__PURE__*/_jsx(UnitCell, {
        children: example.teamSize
      })
    }, {
      content: /*#__PURE__*/_jsx(AmountCell, {
        children: example.price
      })
    }];
    return {
      cells
    };
  });
};
export const PerUserPricingTiersTable = props => {
  const {
    items,
    currency,
    billingCycle
  } = props;
  return /*#__PURE__*/_jsx(DynamicTable, {
    head: {
      cells: getHeader(billingCycle)
    },
    rows: getRows(items, currency, billingCycle)
  });
};